// The user's own goals (courses, articles, certifications...), kept at
// users/{uid}/careerGoals/{id}. They used to have their own Career Building
// page; now Interview Prep plans their steps in with the rest of the prep.

import type { PlanGoal } from "./prepPlanner";

export type GoalCategory = "skill" | "certification" | "experience" | "networking";

export type GoalStep = { id: string; title: string; completed: boolean };

export type CareerGoal = {
  id: string;
  title: string;
  category: GoalCategory;
  /** The steps, in order ("lessons" from the Career Building page) */
  lessons: GoalStep[];
  /** yyyy-mm-dd */
  targetDate?: string;
  /** How long one step takes; DEFAULT_STEP_MINUTES when unset (goals from before) */
  stepMinutes?: number;
  createdAt?: unknown;
};

export const CATEGORY_LABEL: Record<GoalCategory, string> = {
  skill: "Skill",
  certification: "Certification",
  experience: "Experience",
  networking: "Networking",
};

export const DEFAULT_STEP_MINUTES = 30;
export const STEP_MINUTE_OPTIONS = [15, 30, 45, 60, 90];

/** What the planner needs: the open steps, in order */
export function toPlanGoal(goal: CareerGoal): PlanGoal {
  return {
    id: goal.id,
    title: goal.title,
    steps: (goal.lessons || []).filter((s) => !s.completed).map(({ id, title }) => ({ id, title })),
    ...(goal.targetDate ? { target: goal.targetDate } : {}),
    stepMinutes: goal.stepMinutes ?? DEFAULT_STEP_MINUTES,
  };
}
